import React, { useState, useEffect, useContext } from 'react';
import Menu from './Menu';
import MenuDisplay from './MenuDisplay';
import OrderButton from './OrderButton';
import Skeleton from '@mui/material/Skeleton';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { CartContext } from '../context/CartContext';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const NotreCartePage = () => {
  const [categories, setCategories] = useState({});
  const [menus, setMenus] = useState([]);
  const [menusPicker, setMenusPicker] = useState([]);
  const { addToCart } = useContext(CartContext);
  const [loading, setLoading] = useState(true);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    fetch(`/assets/json/carte.json?v=${Date.now()}`)
      .then(response => response.json())
      .then(data => {
        setCategories(data.categories);
        setMenus(data.menus);
        setMenusPicker(data['menus-picker']);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleAddToCart = (item) => {
    addToCart(item);
    setSnackbarMessage(`${item.nom} ajouté au panier !`);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <div>
      {loading ? (
        <Skeleton variant="rectangular" width={300} height={400} />
      ) : (
        <>
          <Menu addToCart={handleAddToCart} />
          <MenuDisplay menus={menus} menusPicker={menusPicker} categories={categories} addToCart={handleAddToCart} />
          <OrderButton />
        </>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NotreCartePage;
